module.exports = __webpack_public_path__ + "static/media/face-blowing-a-kiss-svgrepo-com.5fbb6a90.svg";